'use client';

import {
  ListRoot,
  type ListProps,
  type ListBaseProps,
  listClasses,
} from './List';
import {
  ListDivider,
  type ListDividerProps,
  type ListDividerBaseProps,
  listDividerClasses,
} from './ListDivider';
import {
  ListItem,
  type ListItemProps,
  type ListItemBaseProps,
  listItemClasses,
} from './ListItem';
import {
  ListItemAffix,
  type ListItemAffixProps,
  type ListItemAffixBaseProps,
  listItemAffixClasses,
} from './ListItemAffix';
import {
  ListItemButton,
  type ListItemButtonProps,
  type ListItemButtonBaseProps,
  listItemButtonClasses,
} from './ListItemButton';
import {
  ListItemText,
  type ListItemTextProps,
  type ListItemTextBaseProps,
  listItemTextClasses,
} from './ListItemText';

const List = Object.assign(ListRoot, {
  Item: ListItem,
  ItemButton: ListItemButton,
  ItemAffix: ListItemAffix,
  ItemText: ListItemText,
  Divider: ListDivider,
});

export {
  List,
  type ListProps,
  type ListBaseProps,
  listClasses,
  type ListItemProps,
  type ListItemBaseProps,
  listItemClasses,
  type ListItemButtonProps,
  type ListItemButtonBaseProps,
  listItemButtonClasses,
  type ListItemAffixProps,
  type ListItemAffixBaseProps,
  listItemAffixClasses,
  type ListItemTextProps,
  type ListItemTextBaseProps,
  listItemTextClasses,
  type ListDividerProps,
  type ListDividerBaseProps,
  listDividerClasses,
};
